import { defineMessages } from 'react-intl';

export default defineMessages({
  judgementAddFormJudgementDate: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.judgement_date',
  },
  judgementAddFormJudgementDateError: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.judgement_date.error_date',
  },
  judgementAddFormResponsibilityShare: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.responsibility_share',
  },
  judgementAddFormConviction: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.conviction',
  },
  responsibiltySharePercentage: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.responsibility_share.percentage',
  },
  uploadDocumentTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.upload_document.title',
  },
  uploadDocumentButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.upload_document.button.title',
  },
  expertiseField: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.expertise',
  },
  selectVictims: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.select_victims',
  },
  selectOpposingPartyRegistrationNumbers: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.registration_numbers',
  },
  submitForm: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.submit',
  },
  cancelForm: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.cancel',
  },
  expertisesSectionTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.expertises_title',
  },
  nameExpertField: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.expert_fields.name',
  },
  adresseExpertField: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.expert_fields.adresse',
  },
  dateExpertiseField: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.expert_fields.date',
  },
  hearingDateTitle: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.title',
  },
  validateRequiredField: {
    id: 'validate.required_field',
  },
  responsibilityShareWarning: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.responsibility_share_warning',
  },
});
